import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { SortableTableComponent } from './sortableTable.component';
import { ProgressIndicatorModule } from '@common/components/ProgressIndicatorComponent/progressIndicator.module';

@NgModule({
  declarations: [
    SortableTableComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatProgressSpinnerModule,
    TranslateModule,
    NgxPaginationModule,
    ProgressIndicatorModule,
  ],
  exports: [
    SortableTableComponent,
  ],
  providers: [],
})
export class SortableTableModule {}



// WEBPACK FOOTER //
// ./src/app/common/components/SortableTableComponent/sortableTable.module.ts